import { debounce } from 'lodash';
import { useCallback, useEffect } from 'react';

import useMutationObserver from '@swf/core/hooks/useMutationObserver';

import useSetCssVariable from './useSetCssVariable';

const mutationObserverHookOptions = {
  attributes: true,
  childList: true,
  subtree: true,
  triggerBeforeMutation: true
};

const useSetHeaderHeight = (
  cssVariableName: string,
  layoutRef?: React.RefObject<HTMLDivElement | null>,
  headerRef?: React.RefObject<HTMLDivElement | null>
) => {
  const { setHeightCssVariableForRef } = useSetCssVariable(layoutRef);

  const setHeaderCssVariable = useCallback(() => {
    setHeightCssVariableForRef(cssVariableName, headerRef);
  }, [headerRef, cssVariableName, setHeightCssVariableForRef]);

  useMutationObserver(headerRef, setHeaderCssVariable, mutationObserverHookOptions);

  useEffect(() => {
    const setHeaderHeightOnResize = debounce(() => {
      setHeaderCssVariable();
    }, 150);

    window.addEventListener('resize', setHeaderHeightOnResize);

    return () => {
      window.removeEventListener('resize', setHeaderHeightOnResize);
    };
  }, [setHeaderCssVariable]);
};

export default useSetHeaderHeight;
